export const VEHICLE_MAIN_INFO_VEHICLES_RESOURCES = {
  // editVehicle:true,
  // editAdmin:true
};
